<template>
  <div class="teacher">
    <img class="avatar" :src="avatar" />
    <h4 class="name">{{ name }}</h4>
    <div class="job">{{ jobs }}</div>
  </div>
</template>

<script>
  export default {
    name: 'TeacherItem',
    props: {
      avatar: String,
      name: String,
      jobs: String,
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.teacher {
  padding: 20px 10px;
  width: 100%;
  background-color: #fff;
  @include flex-center(column);
  justify-content: flex-start;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .avatar {
    margin-bottom: 10px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .name {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    line-height: 2;
  }

  .job {
    color: #999;
    font-size: 14px;
    line-height: 1.75;
    text-align: center;
  }
}
</style>
